import script from "./YFHWPage18.vue?vue&type=script&setup=true&lang=js"
export * from "./YFHWPage18.vue?vue&type=script&setup=true&lang=js"

import "./YFHWPage18.vue?vue&type=style&index=0&id=22c158cc&scoped=true&lang=less"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22c158cc"]])

export default __exports__